const prod = {
    stage: "prod",    
    portalLogin: "https://bmgf.sharepoint.com/sites/cavd",
    loginHelp: "/app/log-in-help",
    baseAPIUrl: "https://func-vaccinesites-prod-wus2-01.azurewebsites.net/api/",
    gtmId: "GTM-M7KZ9ZB"
};

const uat = {
    stage: "uat",
    portalLogin: "https://bmgf.sharepoint.com/sites/cavd_dev",
    loginHelp: "/app/log-in-help",
    baseAPIUrl: "https://func-vaccinesites-stg-wus2-01.azurewebsites.net/api/",
    gtmId: "GTM-58PBHW4"
}

const dev = {
    stage: "dev",
    portalLogin: 'https://bmgf.sharepoint.com/sites/cavd_dev',
    loginHelp: "/app/log-in-help",
    baseAPIUrl: "https://func-vaccinesites-dev-wus2-01.azurewebsites.net/api/",
    gtmId: "GTM-58PBHW4"
};


let env = dev;
if (process.env.REACT_APP_STAGE === 'production') {
    env = prod;
} else if (process.env.REACT_APP_STAGE === 'uat') {
    env = uat;
}

env.website = 'cavd';
export const config = env;
